import { useEffect } from 'react';

export const useMountEffect = (effect: () => void | (() => void)) => {
	// biome-ignore lint/plugin/no-use-effect: useMountEffect implementation
	// biome-ignore lint/correctness/useExhaustiveDependencies: Mount effect should only run once
	useEffect(effect, []);
};
